import { render } from "./HeaderMegaposData.vue?vue&type=template&id=0b1accf8"
const script = {}

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__